import { defineComponent as n, openBlock as v, createBlock as r, unref as m, mergeProps as h, withCtx as p, createElementVNode as l } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const d = /* @__PURE__ */ n({
  name: "IconGpu",
  __name: "IconGpu",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (a, e) => (v(), r(m(u), h(t, { "view-box": "0 0 24 24" }), {
      default: p(() => [...e[0] || (e[0] = [
        l("path", {
          "fill-rule": "evenodd",
          d: "M2.75 6A2.25 2.25 0 0 1 5 3.75h14A2.25 2.25 0 0 1 21.25 6v12A2.25 2.25 0 0 1 19 20.25H5A2.25 2.25 0 0 1 2.75 18V6M5 5.25A.75.75 0 0 0 4.25 6v5.25h2.5v-6H5m3.25 0v6h3v-6h-3m-1.5 7.5h-2.5V18A.75.75 0 0 0 5 18.75h1.75v-6m1.5 6v-6h3v6h-3m4.5-13.5v6h3v-6h-3m0 7.5h3v6h-3v-6m4.5 0v6H19A.75.75 0 0 0 19.75 18v-5.25h-2.5m0-7.5v6h2.5V6A.75.75 0 0 0 19 5.25h-1.75",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
